<template>
  <v-flex xs12>
    <h5 style="font-weight: medium">Stripe</h5>
    <v-row wrap align-start>
      <v-btn small class="text-none" target="_blank" :href="cardPaymentLink"
        >View on Stripe</v-btn
      >
      <v-flex>
      <StripeRefund :bookingForm="bookingForm" />
      </v-flex>
      <v-flex pt-4>
        <p style="padding-top: 12px !important; font-size: 12px;" v-if="bookingForm.booking.refunded == true">
          Booking has already been fully/partially refunded
        </p>
      </v-flex>
      <p v-if="hasOutboundAndReturn" v-html="outboundAndReturnString"></p>
    </v-row>
  </v-flex>
</template>

<script>
import StripeRefund from "@/components/booking/StripeRefund.vue";

import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "StripeTransaction",
  mounted: function () {
    console.log("StripeTransaction");
  },
  components: {
    StripeRefund,
  },
  props: {
    bookingForm: Object,
  },
  data: function () {
    return {
      dialog: false,
      loading: false,
      transactions: [],
    };
  },
  computed: {
    hasOutboundAndReturn: function() {
      return (this.bookingForm.booking.cart != null && this.bookingForm.booking.cart.outboundBookingId != null && this.bookingForm.booking.cart.returnBookingId != null);
    },
    outboundAndReturnString: function() {
      if (this.bookingForm.booking.cart != null && this.bookingForm.booking.cart.outboundBookingId != null && this.bookingForm.booking.cart.returnBookingId != null) {
        return "This stripe payment is associated with two bookings.<br><b>Outbound:</b> " + this.bookingForm.booking.cart.outboundBookingId + "<br><b>Return:</b> " + this.bookingForm.booking.cart.returnBookingId;
      } 

      return "";
    },
    cardPaymentLink: function () {
      return (
        "https://dashboard.stripe.com/search?query=" +
        (this.bookingForm.booking.cart == null
          ? this.bookingForm.booking.id
          : this.bookingForm.booking.cart.cartId)
      );
    },
    transactionTable: function () {
      if (this.transactions != null && this.transactions.length > 0) {
        var table = "";

        for (var i = 0; i < this.transactions.length; i++) {
          var transaction = this.transactions[i];

          var tr = "<tr>";

          var date = new Date(transaction["created"] * 1000);

          var td =
            '<td style="border: 1px solid black; padding: 10px;">' +
            date.getDate() +
            "/" +
            (date.getMonth() + 1) +
            "/" +
            date.getFullYear() +
            " " +
            date.getHours() +
            ":" +
            date.getMinutes() +
            ":" +
            date.getSeconds() +
            "</td>";

          tr += td;

          td =
            '<td style="border: 1px solid black; padding: 10px;">' +
            transaction["description"] +
            "</td>";

          tr += td;

          if (transaction["captured"] == true) {
            td =
              '<td style="border: 1px solid black; padding: 10px;">Captured</td>';
            tr += td;
          } else if (transaction["refunded"] == true) {
            td =
              '<td style="border: 1px solid black; padding: 10px;">Refunded</td>';
            tr += td;
          } else if (transaction["status"] == "failed") {
            td =
              '<td style="border: 1px solid black; padding: 10px;">Failed: ' +
              transaction["failure_message"] +
              "</td>";
            tr += td;
          } else {
            td =
              '<td style="border: 1px solid black; padding: 10px;">Pre-auth</td>';
            tr += td;
          }

          if (transaction["refunded"] == true) {
            if (
              transaction["refunds"] != null &&
              transaction["refunds"]["data"] != null &&
              transaction["refunds"]["data"][0] != null &&
              transaction["refunds"]["data"][0]["metadata"] != null &&
              transaction["refunds"]["data"][0]["metadata"]["reason"] != null
            ) {
              td =
                '<td style="border: 1px solid black; padding: 10px;"><b>Refunded</b>: £' +
                (transaction["amount"] / 100).toFixed(2) +
                " <br/> Reason: " +
                transaction["refunds"]["data"][0]["metadata"]["reason"] +
                " </td>";
            } else {
              td =
                '<td style="border: 1px solid black; padding: 10px;"><b>Refunded</b>: £' +
                (transaction["amount"] / 100).toFixed(2) +
                "</td>";
            }
            tr += td;
          } else if (transaction["captured"] == true) {
            if (transaction["amount_refunded"] == 0) {
              td =
                '<td style="border: 1px solid black; padding: 10px;"><b>Final charge</b>: £' +
                (transaction["amount"] / 100).toFixed(2) +
                "</td>";
              tr += td;
            } else {
              td =
                '<td style="border: 1px solid black; padding: 10px;"><b>Pre-auth</b>: £' +
                (transaction["amount"] / 100).toFixed(2) +
                "<br/><b>Refunded</b>: £" +
                (transaction["amount_refunded"] / 100).toFixed(2) +
                "<br/><b>Final charge</b>: £" +
                (
                  (transaction["amount"] - transaction["amount_refunded"]) /
                  100
                ).toFixed(2) +
                "</td>";
              tr += td;
            }
          } else if (transaction["status"] == "failed") {
            td =
              '<td style="border: 1px solid black; padding: 10px;"><b>Failed</b></td>';
            tr += td;
          } else {
            td =
              '<td style="border: 1px solid black; padding: 10px;"><b>Pre-auth</b>: £' +
              (transaction["amount"] / 100).toFixed(2) +
              "</td>";
            tr += td;
          }

          if (
            transaction["charges"]["data"][0]["payment_method_details"][
              "card"
            ] != null
          ) {
            td =
              '<td style="border: 1px solid black; padding: 10px;">' +
              transaction["charges"]["data"][0]["payment_method_details"][
                "card"
              ]["brand"] +
              " " +
              transaction["charges"]["data"][0]["payment_method_details"][
                "card"
              ]["last4"] +
              "</td>";
            tr += td;
          } else {
            td =
              '<td style="border: 1px solid black; padding: 10px;">' +
              transaction["source"]["type_data"]["brand"] +
              " " +
              transaction["source"]["type_data"]["last4"] +
              "</td>";
            tr += td;
          }

          tr += "</tr>";

          table += tr;
        }

        console.log(table);
        return table;
      } else {
        return '<tr><td style="border: 1px solid black; padding: 10px;" colspan="5">No transactions recorded</td></tr>';
      }
    },
  },
  methods: {
    getTransactions: async function () {
      this.loading = true;
      try {
        var url = `${this.$store.state.apiUrl}/customer/getTransactions?id=${this.bookingForm.user.id}`;

        let response = await axios.get(url, {
          params: {},
        });

        if (response.data.error == null) {
          console.log(this.transactions);
          this.transactions = response.data.transactions;
        } else {
          alert(response.data.error);
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get customer " + error);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.v-timeline-item {
  padding-bottom: 8px !important;
}

.v-timeline {
  padding-top: 8px !important;
}
</style>

   
